module.exports = __webpack_public_path__ + "img/showcase-hero-bg.b1b4defb.jpg";